import styled from "styled-components";

export const WithdrowInfoBox = styled.div`
  display: flex;
  padding: 24px;
  background: ${(props) => props.theme.colors.white100};
  border-radius: 10px;
  box-shadow: ${(props) => props.theme.shadows.box};
  flex-direction: column;
  gap: 16px;
`;

export const Title = styled.div`
  font-size: 1.6rem;
  font-weight: 600;
`;

export const Text = styled.div`
  font-size: 1.3rem;
  line-height: 140%;

  span {
    color: ${(props) => props.theme.colors.primary100};
    font-weight: 600;
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;

export const ContentBox = styled.div`
  display: flex;
  padding: 16px;
  background: ${(props) => props.theme.colors.black2};
  border-radius: 6px;
  flex-direction: column;
  gap: 16px;
`;

export const Content = styled.div`
  display: flex;
  font-size: 1.3rem;
  line-height: 140%;
  word-break: keep-all;
  flex-direction: column;
  gap: 3px;

  span {
    color: ${(props) => props.theme.colors.primary100};
    font-size: 1.2rem;
    font-weight: 600;
  }
`;
